import React, { Component } from 'react';
import { connect } from 'react-redux'; 
import { withTranslation } from 'react-i18next'; 

class POSPrintLabel extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            print: false
        };
    }

    componentWillReceiveProps(newProps) {
        if (this.state.print !== newProps.print && newProps.print !== undefined && newProps.print !== null) {
            if (newProps.print === true || newProps.print === false) {
                this.setState({ print: newProps.print });
            }
        }
    }

    componentDidUpdate() {
        if (this.state.print === true) {
            this.print();
        }
    }

    print = () => {
        document.getElementById('to-print').innerHTML = document.getElementById('pos-labels').innerHTML;
        window.print();
        this.props.onPrintCompleted();
    }

    render() {
        const { t } = this.props; 
        const p = this.props;
        const width = '190px';
        const style = {
            width: width,
            height: 'auto',
            paddingTop: '0px',
            paddingLeft: '15px',
            paddingRight: '5px',
            pageBreakAfter: 'always'
        };
        const textStyle = {
            fontSize: '10px',
            margin: '0'
        };

        return p.order && p.products ? (
            <div id={p.name} style={{ display: 'none' }}>
                {
                    p.products.map((item, index) => {
                        if (item.status === 1 || item.status === 2) {
                            return (<div style={style} id={p.name + '-content'} key={index}>
                                <div className="row">
                                    <div className="col-lg-12">
                                        <p style={textStyle}><u>{p.store.name}</u></p>
                                        <p style={textStyle}>
                                            <span className="pull-left">{p.store.phone}</span>
                                            <span className="pull-right">{new Date().toDateString()}</span>
                                        </p>
                                        <br />
                                        {
                                            p.order.patientId && p.order.patientId > 0 ?
                                                (<p style={textStyle}>{p.order.patientId}</p>) : null
                                        }
                                        <p style={textStyle}><b>{item.name}</b></p>
                                        {
                                            item.isUnitProduct ? (<p style={textStyle}>{item.quantity} UNIT(S)</p>)
                                                : (<p style={textStyle}>{item.quantity} GR</p>)
                                        }
                                        <p style={textStyle}><i>{t('pos.printLabel.medUseOnly')}</i></p>
                                    </div>
                                </div>
                            </div>);
                        }
                        return null;
                    })
                }
            </div>
        ) : null;
    }
}

function mapStateToProps(state) {
    return {
        store: state.common.store
    };
}

export default connect(mapStateToProps)(withTranslation()(POSPrintLabel));